<template>
  <div class="selected-card-details">
    <div :class="['card-item', `card-${card.cardBrand ? card.cardBrand.toLowerCase() : ''}`]">
      <div class="card-item__info">
        <div class="card-item__brand">
          <SvgImage
            v-if="card.cardBrand"
            :width="ismobile ? '50' : '75'"
            :height="ismobile ? '50' : '75'"
            :icon="`card_list_${card.cardBrand}`"
          />
        </div>
        <h4 class="card-item__number">
          {{ censoredText(decrypt(card.number, card.cvi)) }}
        </h4>
        <div
          v-if="!isMobile"
          class="card-item__details"
        >
          <div class="card-item__name">
            <label>{{ $t('Cardholder Name') }}</label>
            <p>{{ decrypt(card.name, card.cvi) }}</p>
          </div>
          <div class="card-item__expiry">
            <label>{{ $t('Expiration Date') }}</label>
            <p>
              {{ `${decrypt(card.month, card.cvi)}/${String(decrypt(card.year, card.cvi)).slice(2, 4)}` }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgImage from '~/components/General/SvgImage.vue';

export default {
  name: 'SelectedCardDetails',
  components: { SvgImage },
  props: {
    card: {
      type: Object,
      required: true,
    },
    decrypt: {
      type: Function,
      required: true,
    },
    censoredText: {
      type: Function,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'assets/themes/_variables.scss';
$content-bg-color: #f9f9f9;
$border-color: #bebebe;
$box-shadow-color: rgba(0, 0, 0, 0.1);
$background-color: #f7f3f3;

.selected-card-details {
    .card-item {
        border: 2px solid var(--secondary-color);
        background-color: var(--background-color);
    }
}

.card-visa {
    background-color: #1E7AF1 !important;
    color: #ffffff;
}

.card-mastercard {
    background-color: #FF7043 !important;
    color: #ffffff;
}

.card-hipercard {
    background-color: #F95454 !important;
    color: #ffffff;
}

.card-elo {
    background-color: #333333 !important;
    color: #ffffff;
}

.payment-cards {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: start;
    max-height: 63vh;
    overflow-y: scroll;
}

.card-item__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    @media(max-width: 768px) {
        flex-direction: row;
        align-items: center;
    }
}

.card-item__actions {
    display: flex;
    align-items: center;
    width: fit-content;
    height: fit-content;

}

.card-item__brand {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-left: auto;
    @media(max-width: 768px) {
       width: 50%;
    }
}

.card-item__brand .card-item__typeImg {
    max-width: 75px;
    max-height: 75px;
    width: auto;
    height: auto;
}

.card-item {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    box-sizing: border-box;
    border: solid 2px $border-color;
    border-radius: 10px;
    padding: 1rem;
    user-select: none;
    box-shadow: 0 4px 6px $box-shadow-color;
    background-color: $background-color;
    font-family: $font-family-base;
    transition: all 0.1s ease-in-out;
    align-items: flex-start;

    &.active {
        border: solid 3px $secondary-color !important;
    }

    @media(max-width: 768px) {
        padding: 0.5rem;
        flex-direction: row;

    }

}

.card-item__number {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 10px;
    @media(max-width: 768px) {
        font-size: 1.1rem;
        width: 100%;
    }
}

.card-item__details {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.card-item__name,
.card-item__expiry {
    font-size: 1rem;
    color: #ffffff;
}

.card-item__name label,
.card-item__expiry label {
    font-size: 0.85rem;
    font-size: 1rem;
    font-weight: bold;
}
</style>
